import {
  DescriptionPage_ProductVariant as DescriptionPageProductVariant,
  DescriptionPage_UpsellType as UpsellType,
} from '__generated__/graphql-types';

import { getUpsellCopy } from 'bundles/stackability-common/stackability-common-index';

import _t from 'i18n!nls/xdp';

type Props = {
  productName: string;
  specializationType: DescriptionPageProductVariant | undefined;
  degreePartnerName?: string;
  upsellType?: UpsellType | null;
  productPagePartnerName?: string;
  disableCtaCopy?: boolean;
};

const getEligibleDegreesDescription = ({
  productName,
  specializationType = DescriptionPageProductVariant.StandardSpecialization,
  degreePartnerName,
  upsellType = null,
  productPagePartnerName,
  disableCtaCopy,
}: Props) => {
  const isSpecialization =
    specializationType !== DescriptionPageProductVariant.StandardSpecialization || !degreePartnerName;

  let description = '';
  let disclaimer: string | undefined;
  const copy = getUpsellCopy().homepagesNavXdp;

  if (isSpecialization) {
    description = copy.eligibleDegreesOffersCreditDescription(productName);
    disclaimer = copy.eligibleDegreesDisclaimerSuccessfulAppRequired;
  } else if (upsellType === UpsellType.PartOf) {
    description = copy.eligibleDegreesPartOfDescription(productName, degreePartnerName ?? _t('a partner'));
    disclaimer = copy.eligibleDegreesDisclaimerSuccessfulAppRequired;
  } else if (upsellType === UpsellType.OffersCredit) {
    description = copy.eligibleDegreesOffersCreditDescription(productName);
    disclaimer = copy.eligibleDegreesDisclaimerSuccessfulAppRequired;
  } else if (upsellType === UpsellType.RelatedTo) {
    description = copy.eligibleDegreesRelatedToDescription(productName, productPagePartnerName ?? _t('a partner'));
  } else {
    description = copy.eligibleDegreesFallbackDescription(productName);
  }

  if (disclaimer && disableCtaCopy) {
    disclaimer = copy.eligibleDegreesDisclaimerSuccessfulAppRequiredNoCta;
  }

  return {
    description,
    disclaimer,
  };
};

export default getEligibleDegreesDescription;
